import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { ProjectBudgetAddContainerComponent } from './project-budget-add-container/project-budget-add-container.component';
import { ProjectBudgetAddComponent } from './project-budget-add/project-budget-add.component';
import { ProjectBudgetContainerComponent } from './project-budget-container/project-budget-container.component';
import { ProjectBudgetContractComponent } from './project-budget-contract/project-budget-contract.component';
import { ProjectBudgetRoute } from './project-budget.route';
import { ProjectBudgetComponent } from './project-budget/project-budget.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as reducer from './store/budget-upload.reducer';
import { BudgetUploadEffects } from './store/budget-upload.effects';
@NgModule({
    declarations: [
        ProjectBudgetContainerComponent,
        ProjectBudgetComponent,
        ProjectBudgetContractComponent,
        ProjectBudgetAddComponent,
        ProjectBudgetAddContainerComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [ProjectBudgetRoute]
        }),
        StoreModule.forFeature(
            reducer.BudgetUploadsFeatureKey,
            reducer.reducer
        ),
        EffectsModule.forFeature([BudgetUploadEffects])
    ],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
})
export class ProjectBudgetModule {}
